import { useSelector } from "react-redux";
import classNames from "classnames";

import { ApplePayButton, PaymentSystem } from "@web-solutions/react-billing";
import { ApplePayTruegateContainer } from "@web-solutions/react-billing/truegate/ApplePayContainer";
import { selectPaymentSystem } from "@web-solutions/core/store/billing/selectors";
import { APP_NAME } from "@web-solutions/core/constants/general";

import classes from "./style.module.scss";
import "./style.scss";
import { useRemoteConfig } from "core/hooks/use-remote-config";

const ApplePay = ({
  options,
  activeProduct,
  className,
  onApplePayClick,
  onApplePaySubmit,
  onApplePayReady,
  onApplePaySuccess,
  onApplePayError,
}) => {
  const email = useSelector((state) => state.profile.email);
  const paymentSystem = useSelector(selectPaymentSystem);
  const { flow } = useRemoteConfig();

  const handleSubmit = (formData) => {
    onApplePaySubmit({ email, ...formData });
  };

  if (paymentSystem === PaymentSystem.TRUEGATE) {
    return (
      <ApplePayTruegateContainer
        product={activeProduct}
        options={options}
        email={email}
        onReady={onApplePayReady}
        onClick={onApplePayClick}
        onSubmit={handleSubmit}
        onSuccess={onApplePaySuccess}
        onError={onApplePayError}
      />
    );
  }

  return (paymentSystem !== PaymentSystem.SOLIDGATE &&
    paymentSystem !== PaymentSystem.PADDLE) ||
    !!process.env.REACT_APP_APPLE_PAY_H2H ? (
    <ApplePayButton
      product={activeProduct}
      label={APP_NAME}
      disabled={!email}
      className={classNames(classes.btn, className)}
      onClick={onApplePayClick}
      onSubmit={handleSubmit}
      // requireEmail={!flow.includes('EMAIL')}
    />
  ) : null;
};

export default ApplePay;
